module.exports = __webpack_public_path__ + "static/media/icon-driving.7f808086.7f808086.png";